import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UiStorage } from '../../lib/services/ui-storage'

@Component({
    standalone: false,
    selector: 'app-bevestiging',
    templateUrl: './bevestiging.component.html',
    styleUrls: ['./bevestiging.component.css']
})
export class BevestigingComponent implements OnInit {
    @Input() model: any;
    style: string;

    constructor(private _router: Router, private _storage: UiStorage) {
        this.model = _storage.load() || {};
        this.style = this.model.style.toLowerCase();
    }

    public onBack() {
        this._storage.save(this.model);
        this._router.navigate(['/verzekerde']);
    }

    ngOnInit() {
    }

}
